export default function calculateScaleAndDim(_width: number, _height: number, innerW: number, innerH: number) {
  let w = _width;
  let h = _height
  if (innerH > innerW) {
    w = _height;
    h = _width * 1.2;
  }
  let scaleW = innerW / w;
  let scaleH = innerH / h;
  let scale = scaleW > scaleH ? scaleH : scaleW;
  let width = scaleW > scaleH ? innerW / scale : w;
  let height = innerH / scale //scaleW > scaleH ? innerH / scale : innerH / scale;
  let layerHeight = scaleW > scaleH ? innerH / scale : h;

  return { scale, width, height, layerHeight }
}